export default "__VITE_ASSET__834ab291__"